import { render, staticRenderFns } from "./ProviderSearchResultCard.vue?vue&type=template&id=1b8820ec&scoped=true"
import script from "./ProviderSearchResultCard.vue?vue&type=script&lang=js"
export * from "./ProviderSearchResultCard.vue?vue&type=script&lang=js"
import style0 from "./ProviderSearchResultCard.vue?vue&type=style&index=0&id=1b8820ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8820ec",
  null
  
)

export default component.exports